import React from 'react'

export default class IconsAlert extends React.Component {
    render() {
        let color = '#C8C5FE'
        if (this.props.color) color = this.props.color
        let className = 'icons-icon'
        return (
            <svg
                className={className}
                style={this.props.style}
                width='16'
                height='16'
                viewBox='0 0 16 16'
                fill='none'
                xmlns='http://www.w3.org/2000/svg'
            >
                <path
                    fillRule='evenodd'
                    clipRule='evenodd'
                    d='M6.60557 3.27921C7.21757 2.19121 8.78317 2.19121 9.39437 3.27921L13.8584 11.2152C14.4584 12.2824 13.688 13.5992 12.4648 13.5992H3.53597C2.31197 13.5992 1.54157 12.2824 2.14157 11.2152L6.60557 3.27921ZM8.79997 11.2C8.79997 11.4122 8.71568 11.6157 8.56566 11.7657C8.41563 11.9157 8.21214 12 7.99997 12C7.7878 12 7.58431 11.9157 7.43429 11.7657C7.28426 11.6157 7.19997 11.4122 7.19997 11.2C7.19997 10.9878 7.28426 10.7844 7.43429 10.6343C7.58431 10.4843 7.7878 10.4 7.99997 10.4C8.21214 10.4 8.41563 10.4843 8.56566 10.6343C8.71568 10.7844 8.79997 10.9878 8.79997 11.2V11.2ZM7.99997 4.80001C7.7878 4.80001 7.58431 4.8843 7.43429 5.03433C7.28426 5.18435 7.19997 5.38784 7.19997 5.60001V8.00001C7.19997 8.21218 7.28426 8.41567 7.43429 8.5657C7.58431 8.71573 7.7878 8.80001 7.99997 8.80001C8.21214 8.80001 8.41563 8.71573 8.56566 8.5657C8.71568 8.41567 8.79997 8.21218 8.79997 8.00001V5.60001C8.79997 5.38784 8.71568 5.18435 8.56566 5.03433C8.41563 4.8843 8.21214 4.80001 7.99997 4.80001Z'
                    fill={color}
                />
            </svg>
        )
    }
}
